// extracted by mini-css-extract-plugin
module.exports =  {"container":"PYfSEA4sl6Tj3yt69Oj2","text":"demvp8ICVlw74pPdhyQi"};